import { GET_COUPON_REQUESTED, GET_ADDCOUPON_REQUESTED, GET_UPDATECOUPON_REQUESTED, GET_DELETECOUPON_REQUESTED } from "resources/actionTypes";

export function getCoupon(data) {
  return {
    type: GET_COUPON_REQUESTED,
    payload: data,
  };
}

export function postAddCoupon(userAddCoupon, toggle) {
  const data = {
    userAddCoupon: userAddCoupon,
    setOpen: toggle,
  }
  return {
    type: GET_ADDCOUPON_REQUESTED,
    payload: data,
  };
}

export function patchUpdateCoupon(userUpdateCoupon) {
  const data = {
    userUpdateCoupon: userUpdateCoupon,
  }
  return {
    type: GET_UPDATECOUPON_REQUESTED,
    payload: data,
  };
}

export function getDeleteCoupon(deletedata) {
  return {
    type: GET_DELETECOUPON_REQUESTED,
    payload: deletedata,
  };
}

